import {
    firstAndLastNameValidator,
    isPhonePrefixAllowed,
    isSpanishPhoneNumber,
    validateFirstAndLastName,
} from '../../components/Validator';
import type { PersonalInfoField, PersonalInfoState } from './personalInfoSlice';

export const validateEmail = (email: string): string | null => {
    if (!emailValidator(email)) {
        return 'registration.error.email.InvalidFormat';
    }
    return null;
};

const emailValidator = (value: string) =>
    /^[\x21-\x26\x28-\x7E]+@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g.test(
        value
    ) && value.length <= 73;

export const validateOptionalPhoneNumber = (phoneNumber: string): string | null => {
    if (phoneNumber === '') {
        return null;
    }
    if (!optionalPhoneNumberValidator(phoneNumber)) {
        return 'registration.error.phoneNumber.InvalidFormat';
    }
    if (isSpanishPhoneNumber(phoneNumber)) {
        return 'registration.error.phoneNumber.spanishRegistrationUnavailable';
    }
    if (!isPhonePrefixAllowed(phoneNumber)) {
        return 'registration.error.phoneNumber.phoneNumberCountryCodeNotSupported';
    }
    return null;
};

// country code +89x is not a valid country code
const optionalPhoneNumberValidator = (value: string) =>
    /^$|^\+[1-9][0-9 ]{5,20}$/.test(value) && !value.startsWith('+89') && !/\s{2,}/.test(value);

export const nameValidator = (value: string) => {
    const errors = [];

    if (!value || value.trim().length === 0) {
        errors.push('registration.error.name.WhitespaceOnly');
    } else if (!!value && value.length > 40) {
        errors.push('registration.error.name.maxNumCharacters');
    } else if (!firstAndLastNameValidator(value)) {
        errors.push('registration.error.name.notAllowedFormat');
    }
    return errors;
};

const isSelectedValidator = (value: boolean | null | undefined): boolean => !!value;

// biome-ignore lint/suspicious/noExplicitAny: suppress out of convenience during migration to biome
export const getFieldValidator = (fieldName: PersonalInfoField): ((value: any) => string | null) => {
    switch (fieldName) {
        case 'lastName':
            return validateFirstAndLastName;
        case 'firstName':
            return validateFirstAndLastName;
        case 'email':
            return validateEmail;
        case 'phoneNumber':
            return validateOptionalPhoneNumber;
        case 'termsAccepted':
            return (value): string | null => (isSelectedValidator(value) ? null : '');
        default:
            return _value => null;
    }
};

export const isPersonalInfoValid = (state: PersonalInfoState): boolean => {
    return (
        state.firstNameValidationMessage === null &&
        state.lastNameValidationMessage === null &&
        state.emailValidationMessage === null &&
        state.phoneNumberValidationMessage === null &&
        !isSpanishPhoneNumber(state.phoneNumber)
    );
};
